import { render, staticRenderFns } from "./paymentConfirm.vue?vue&type=template&id=f13c3332&scoped=true&"
import script from "./paymentConfirm.vue?vue&type=script&lang=ts&"
export * from "./paymentConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./paymentConfirm.vue?vue&type=style&index=0&id=f13c3332&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13c3332",
  null
  
)

component.options.__file = "paymentConfirm.vue"
export default component.exports